import { logger } from './logger';

export interface StorePersistFailureEntry {
  event_type: string;
  recording_id?: string;
  details?: unknown;
}

export interface StorePersistFailureOptions {
  /**
   * Whether this recording's audio lives only in memory, so the failure is
   * expected rather than a fault. Per recording, never the tab-wide flag, which
   * would silence a genuine failure on a durable one.
   *
   * Two encodings are correct and neither generalises to the other site. Row
   * provenance (`store.ts`): the row itself says the recording is memory-backed,
   * which is what a missing row means there. Error identity
   * (`isMemoryOnlyWriteError`, write paths): the fence refusing this write is the
   * only proof available, because the write never reached a row to ask.
   */
  memoryOnly: boolean;
  /** What an unexpected failure deserves; a missing row is a warn, a refused write an error. */
  level?: 'warn' | 'error';
}

/**
 * The one demotion policy for ledger writes memory-only mode is expected to
 * refuse, so no site hand-rolls it and buries real faults under one error per
 * chunk.
 */
export const logStorePersistFailure = (
  entry: StorePersistFailureEntry,
  { memoryOnly, level = 'error' }: StorePersistFailureOptions
): void => {
  if (memoryOnly) logger.debug(entry);
  else logger[level](entry);
};
